import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=2bcd9d16&scoped=true"
import script from "./Form1.vue?vue&type=script&lang=ts"
export * from "./Form1.vue?vue&type=script&lang=ts"
import style1 from "./Form1.vue?vue&type=style&index=1&id=2bcd9d16&prod&scoped=true&lang=css"
import style2 from "./Form1.vue?vue&type=style&index=2&id=2bcd9d16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd9d16",
  null
  
)

export default component.exports